import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import envConfig from '../../envConfig';
import RaaAuthenticatedRemoteService from '../../utility/RaaAuthenticatedRemoteService';

const selectJWTToken = (state) => state.jwt.token;

const fetchJWT = createAsyncThunk('jwt/fetchToken', async (_, { rejectWithValue }) => {
  try {
    const response = await RaaAuthenticatedRemoteService.globalInstance().get(`${envConfig.raaUrl}/user/data/session`);
    return response.jwt;
  } catch (error) {
    return rejectWithValue({
      name: error.name,
      message: error.message,
      data: error.data,
    });
  }
});

const initialState = {
  loading: false,
  token: '',
  hasErrors: false,
};

const jwtSlice = createSlice({
  name: 'jwt',
  initialState,
  reducers: {
    clearJwtSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJWT.fulfilled, (state, action) => {
        state.token = action.payload;
        state.loading = false;
      })
      .addCase(fetchJWT.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchJWT.rejected, (state) => {
        state.loading = false;
        state.hasErrors = true;
      });
  },
});

const { actions, reducer } = jwtSlice;

export const { clearJwtSlice } = actions;
export {
  fetchJWT,
  selectJWTToken,
};
export default reducer;
